export enum ReviewerStatusEnum {
  Approved = 1,
  ApprovedWithReservation = 2,
  Reproved = 3,
  Waiting = 4,
}
